var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.167,
    height: 14.167,
    viewBox: "0 0 14.167 14.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-download",
    "data-name": "Icon awesome-download",
    d: "M5.977,0H8.19a.662.662,0,0,1,.664.664V5.313h2.427a.552.552,0,0,1,.39.944L7.463,10.468a.536.536,0,0,1-.755,0L2.493,6.256a.552.552,0,0,1,.39-.944H5.313V.664A.662.662,0,0,1,5.977,0Zm8.19,10.4v3.1a.662.662,0,0,1-.664.664H.664A.662.662,0,0,1,0,13.5V10.4A.662.662,0,0,1,.664,9.74H4.723L6.079,11.1a1.418,1.418,0,0,0,2.009,0L9.444,9.74H13.5A.662.662,0,0,1,14.167,10.4Zm-3.431,2.435a.553.553,0,1,0-.553.553A.555.555,0,0,0,10.736,12.839Zm1.771,0a.553.553,0,1,0-.553.553A.555.555,0,0,0,12.507,12.839Z",
    fill: "#1492e6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBlue);
export default __webpack_public_path__ + "static/media/Download-blue.ffa7752f1a414c202568f722d4bc317b.svg";
export { ForwardRef as ReactComponent };